export default function Footer({ onNavigate }) {
  return (
    <footer data-testid="site-footer" className="border-t border-[#283244] bg-[#0A0D12]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <a
          href="#top"
          data-testid="footer-logo"
          onClick={(e) => { e.preventDefault(); onNavigate("#top"); }}
          className="flex items-center gap-3"
        >
          <img src="/logo-full.png" alt="ACPZ Consultancy" className="h-11 rounded-md" />
        </a>
        <div className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#64748B] text-center">
          Aluminium · Copper · Lead · Zinc
          <span className="block mt-1.5 text-[10px] text-[#475569]">LME · COMEX · SME — ISRI Grades — HS 7404 / 7601 / 7604</span>
        </div>
        <div className="text-xs text-[#64748B]" data-testid="footer-copyright">
          &copy; 2026 ACPZ Consultancy Ltd. All rights reserved.
          <span className="block mt-1.5 text-[#475569]" data-testid="footer-registered-office">Registered Office: 51 Hurrell Drive, Harrow HA2 6DY, UK · Company No. 16715343 · Landline: +44 20 8473 7419</span>
        </div>
      </div>
    </footer>
  );
}
